module.exports = __webpack_public_path__ + "img/picto-online.71e5e565.svg";